import { render, staticRenderFns } from "./ModrEditMain.vue?vue&type=template&id=18147ce4&scoped=true&"
import script from "./ModrEditMain.vue?vue&type=script&lang=js&"
export * from "./ModrEditMain.vue?vue&type=script&lang=js&"
import style0 from "./ModrEditMain.vue?vue&type=style&index=0&id=18147ce4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18147ce4",
  null
  
)

export default component.exports